import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const downtimeAnalysisReportTodo = createAsyncThunk('downtimeAnalysisReport', async ({ params, navigate }) => {
    try {
        const baseUrl = process.env.REACT_APP_API_URL
        const headers = { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        const [summaryRes, priorityRes, deptPerfRes, weeklyRes] = await Promise.all([
            axios({
                method: 'GET',
                url: baseUrl + `reports/maintenance-summary`,
                params: {
                    from_date: params?.from_date,
                    to_date: params?.to_date,
                },
                headers,
            }),
            axios({
                method: 'GET',
                url: baseUrl + `reports/downtime-by-priority-monthly`,
                params: {
                    from_date: params?.from_date,
                    to_date: params?.to_date,
                    maintanance_type: params?.maintanance_type || undefined,
                },
                headers,
            }),
            axios({
                method: 'GET',
                url: baseUrl + `reports/department-performance`,
                params: {
                    from_date: params?.from_date,
                    to_date: params?.to_date,
                    service_department_id: params?.service_department_id || undefined,
                    maintanance_type: params?.maintanance_type || undefined,
                },
                headers,
            }),
            axios({
                method: 'GET',
                url: baseUrl + `reports/maintenance-by-department-weekly`,
                params: {
                    from_date: params?.from_date,
                    to_date: params?.to_date,
                },
                headers,
            }),
        ])

        return { summaryRes, priorityRes, deptPerfRes, weeklyRes, navigate }
    } catch (error) {
        return error.response
    }
})

const handleAuthError = (payload, navigate) => {
    if (payload?.status === 401) {
        showTokenExpiredAlert(payload?.data?.message, navigate)
        return true
    }
    if (payload?.status === 403) {
        showAccessDeniedAlert(navigate)
        return true
    }
    return false
}

const downtimeAnalysisReportSlice = createSlice({
    name: 'downtimeAnalysisReport',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(downtimeAnalysisReportTodo.fulfilled, (state, action) => {
            const payload = action?.payload

            if (payload?.summaryRes) {
                const { summaryRes, priorityRes, deptPerfRes, weeklyRes, navigate } = payload
                const responses = [summaryRes, priorityRes, deptPerfRes, weeklyRes]

                if (responses.some((res) => res?.status === 401 || res?.status === 403)) {
                    const failed = responses.find((res) => res?.status === 401 || res?.status === 403)
                    handleAuthError(failed, navigate)
                    state.data = null
                    return
                }

                if (responses.every((res) => res?.status === 200)) {
                    state.data = {
                        summary: summaryRes.data.data,
                        downtimeByPriority: priorityRes.data.data,
                        departmentPerformance: deptPerfRes.data.data,
                        maintenanceByDepartmentWeekly: weeklyRes.data.data,
                    }
                } else {
                    state.data = null
                }
                return
            }

            if (payload?.status === 401) {
                showTokenExpiredAlert(payload?.data?.message, action.meta.arg.navigate)
            } else if (payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = null
            }
        })
        builder.addCase(downtimeAnalysisReportTodo.rejected, () => { })
    }
})

export default downtimeAnalysisReportSlice.reducer
